import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import businessImg1 from '../../assests/MenuServies/busniess-Img1.svg';
import businessImg2 from '../../assests/MenuServies/busniess-Img2.svg';
import businessImg3 from '../../assests/MenuServies/busniess-Img3.svg';
import './BusinessContainer.css';
import check from"../../assests/check-img.svg";

const BusinessNeeds: React.FC = () => {
  return (
        <div style={{display:"flex",justifyContent:"center"}}>
    <div className="businessContainer  py-5 ">
      <div className="row align-items-center justify-content-between">

        {/* Left Content */}
        <div className="col-12 col-lg-6 textBlock mb-4 mb-lg-0 business-left">
          <h2 className='needs-h2'>Tailored to Your Business Needs</h2>
          <p className='needs-p'>
            One size doesn’t fit all and neither should your cloud strategy. We design solutions.
          </p>
          <ul className="list">
            <li>
              <img src={check} alt="check" className="text-success-need" />
              <span><strong>SaaS Companies</strong> scaling rapidly with high agility needs.</span>
            </li>
            <li>
              <img src={check} alt="check" className="text-success-need" />
              <span><strong>Enterprises</strong> with complex multi-cloud environments.</span>
            </li>
            <li>
              <img src={check} alt="check" className="text-success-need" />
              <span><strong>Corporate & Industry Leaders</strong> balancing innovation with cost control.</span>
            </li>
          </ul>
        </div>

        {/* Right Images */}
<div className="col-12 col-lg-5 imageBlock">
  <div className="row g-3 align-items-center">
    <div className="col-6 col-md-6">
      <img src={businessImg3} alt="Collaboration" className="img-fluid-needs" />
    </div>
    <div className="col-6 col-md-6 d-flex flex-column justify-content-between">
      <img src={businessImg2} alt="Partnering" className="img-fluid-needs mb-2" />
      <img src={businessImg1} alt="Cloud SaaS" className="img-fluid-needs" />
    </div>
  </div>
</div>


      </div>
    </div>
    </div>
  );
};

export default BusinessNeeds;
